import { FluxType } from './FluxType';

export const FluxRoutes: Record<keyof typeof FluxType, string> = {
  [FluxType.RPSI]: '/fluxs/import-rpsi',
  [FluxType.ALIENATION_ETAT_BIENS]: '/fluxs/vente-dossiers',
  [FluxType.ALIENATION_FOURRIERE]: '/fluxs/lieux-depot',
  [FluxType.ALIENATION_AUTORITE_FOURRIERE]: '/fluxs/autorite-fourriere',
  [FluxType.ANTAI]: '/fluxs/evenements-antai',
};
